import { useEffect, useState } from "react";

import { swSettings } from "app/common/services/swSettings";
import { i18nFilter } from "app/filters/i18nFilter";
import { TitleWidget } from "app/pages/digital-suite/home-page/components/HomePageTrialNTLayout/DigitalSuiteTrialHomePageStyled";
import type { IBasePopularAction } from "app/pages/digital-suite/home-page/components/PopularActions/PopularAction";
import { PopularAction } from "app/pages/digital-suite/home-page/components/PopularActions/PopularAction";
import {
    PopularActionsBody,
    PopularActionsWrapper,
} from "app/pages/digital-suite/home-page/components/PopularActions/styledPopularAction";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

enum EState {
    MARKET_LEADERS = "digitalsuite_marketresearch_webmarketanalysis_mapping",
}
const getHref = (state: EState) => {
    switch (state) {
        case EState.MARKET_LEADERS:
            const marketLeadersState = proNavigator.getState(EState.MARKET_LEADERS);
            const configId = proNavigator.getConfigId(marketLeadersState);
            const { defaultParams } = swSettings.components[configId];
            return proNavigator.href(
                EState.MARKET_LEADERS,
                defaultParams
                    ? { ...defaultParams, duration: "3m" }
                    : {
                          category: "All",
                          duration: "3m",
                          country: 999,
                          webSource: "Total",
                      },
            );
        default:
            return proNavigator.href(state);
    }
};
const onClick = (state: EState) => {
    if (state === EState.MARKET_LEADERS) {
        return allTrackers.dispatchTrackEvent("Button", "click", "Popular Actions/Go To/Explore industry trends");
    }
};
const i18n = i18nFilter();

interface IPopularActionWithState extends IBasePopularAction {
    state: EState;
}
const popularActions: IPopularActionWithState[] = [
    {
        imgUrl: "images/homepage/speaker.svg",
        text: i18n("growth.homepage.popularPages.industryTrends"),
        state: EState.MARKET_LEADERS,
    },
];

export const PopularActions = () => {
    const [windowSize, setWindowSize] = useState(window.innerWidth);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize(window.innerWidth);
        };

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    const getNumberOfPopularActions = () => (windowSize < 1400 ? popularActions.length - 1 : popularActions.length);

    return (
        <PopularActionsWrapper data-automation="platform-homepage-popular-actions">
            <TitleWidget data-automation={"popular-actions-title"}>
                {i18n("growth.homepageTrial.popularActions.title")}
            </TitleWidget>
            <PopularActionsBody>
                {popularActions.slice(0, getNumberOfPopularActions()).map((popularAction) => (
                    <PopularAction
                        onClick={() => {
                            onClick(popularAction.state);
                        }}
                        key={popularAction.text}
                        imgUrl={popularAction.imgUrl}
                        text={popularAction.text}
                        href={getHref(popularAction.state)}
                    />
                ))}
            </PopularActionsBody>
        </PopularActionsWrapper>
    );
};
